module.exports = __webpack_public_path__ + "static/Invoice-System-6-4ca1613e6fd31dfa0f7b502932a84384.svg";